"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockDiscountApplication = exports.mockCheckout = void 0;
const line_item_1 = require("./line_item");
function mockCheckout(overrides = {}) {
    return {
        id: '123456',
        lineItems: {
            edges: [
                {
                    node: (0, line_item_1.mockLineItem)(),
                },
            ],
        },
        webUrl: 'https://omnia-fishing.example.com/1978957881/checkouts/e9e3577309e516290b79af8c3cf90f60?key=c7527a9abdc2962aa7fdd118552e9acc',
        completedAt: null,
        subtotalPrice: {
            amount: '7.49',
        },
        lineItemsSubtotalPrice: {
            amount: '7.49',
        },
        discountApplications: {
            edges: [],
        },
        appliedGiftCards: [],
        ...overrides,
    };
}
exports.mockCheckout = mockCheckout;
function mockDiscountApplication(overrides = {}) {
    return {
        targetSelection: 'ALL',
        allocationMethod: 'ACROSS',
        targetType: 'LINE_ITEM',
        code: 'MOCK_DISCOUNT',
        applicable: true,
        value: {
            __typename: 'PricingPercentageValue',
            percentage: 10,
        },
        ...overrides,
    };
}
exports.mockDiscountApplication = mockDiscountApplication;
